export default __webpack_public_path__ + "static/leva-incastro-bq-4-e7fa66fa962d74ea2e140039501fdb6b.jpg";